import { BrowserRouter } from "react-router-dom";
import AppRouter from "./router/index";
import "./styles/CustomScroll.css"; // Asegúrate de importar el archivo CSS

function App() {
  return <AppRouter />;
}

export default App;
